import React from 'react';
import Step0 from './Step0';
import Step1 from './Step1';
import Step2 from './Step2';

const stepComponents = [Step0, Step1, Step2];

const Index = ({ step }) => {
  const stepsWithNumbers = stepComponents.map((StepComponent, index) => {
    return <StepComponent key={index} number={index} />;
  });

  return stepsWithNumbers[step];
};

export default Index;
